'use client';

import type { LibraryItem } from '@/app/saved/lib/library';
import PublishPanel from '@/app/designs/components/PublishPanel';
import { designTypeForLibraryType } from '@/app/lib/community/shared';

/**
 * "Publish to community" inside My Library's quick-look modal. The build is already saved, so the
 * publish names this item's own id. Renders nothing for a type that has no community adapter.
 */
export default function PublishDesignPanel({ item }: { item: LibraryItem }) {
  const designType = designTypeForLibraryType(item.type);
  if (!designType) return null;
  // A player's skin saved from a username lookup is someone else's, and has no texture of its own to publish.
  if (designType === 'skin' && typeof item.metadata.skinUrl === 'string') {
    return <p className="basis-full text-xs text-zinc-500">A player’s skin loaded by username can’t be published to the community.</p>;
  }
  return <PublishPanel designType={designType} defaultTitle={item.name} resolveElementId={async () => ({ id: item.id })} />;
}
